var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('config-main-title',[_vm._v("\n        Protocolo de Envio da Recepção\n    ")]),_c('guias',{attrs:{"tipo":"envio","id_usuario":_vm.id_usuario}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }